import type { WidgetConfig } from './types.js';

export function parseConfig(container: HTMLElement): WidgetConfig {
  const attr = (name: string): string | null =>
    container.getAttribute(`data-${name}`);

  const numAttr = (name: string, min: number, max: number, fallback: number): number => {
    const raw = attr(name);
    if (raw === null) return fallback;
    const n = parseInt(raw, 10);
    return Number.isNaN(n) ? fallback : Math.max(min, Math.min(max, n));
  };

  const boolAttr = (name: string, fallback: boolean): boolean => {
    const raw = attr(name);
    if (raw === null) return fallback;
    return raw !== 'false' && raw !== '0';
  };

  return {
    feedUrl: attr('feed-url') ?? '',
    layout: attr('layout') === 'slider' ? 'slider' : 'grid',
    columns: numAttr('columns', 1, 4, 3),
    maxItems: numAttr('max-items', 1, 20, 6),
    apiBase: attr('api-base') ?? 'https://api.rsswidget.io',
    theme: (['light', 'dark', 'auto'].includes(attr('theme') ?? '')
      ? (attr('theme') as WidgetConfig['theme'])
      : 'auto'),
    showReadingTime: boolAttr('show-reading-time', true),
    showDate: boolAttr('show-date', true),
    cardImageHeight: numAttr('card-image-height', 100, 500, 200),
  };
}
